import { useEffect, useState } from "react";
import { useApi } from "../../../../services/HttpService";
import ScrollableDataGrid from "../../../../components/tables/ScrollableDataGrid";
import { GridCell, GridColDef, GridRow } from "@mui/x-data-grid";
import {
  Alert,
  Box,
  Button,
  Grid,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { TabPanel, TabProps } from "../../../../components/ui/TabPanel";
import { AddOutlined, LaunchOutlined } from "@mui/icons-material";
import { CreateDCP } from "./CreateDCP";

const mainColumns: GridColDef[] = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "name", headerName: "Project name", width: 130 },
  { field: "identifier", headerName: "Identifier", width: 130 },
  { field: "identifier_public", headerName: "Public identifier", width: 130 },
  { field: "host", headerName: "Host", width: 160 },
  { field: "website", headerName: "Has website", width: 250 },
  { field: "website_host", headerName: "Website host", width: 150 },
];

export const LADCP = () => {
  const { api, isLoading, error } = useApi();

  const [list, setList] = useState([]);

  const getList = () => {
    api("/la-dcp/list", "GET", { primaries: true }).then((res) => {
      if (res) {
        if (res.statusCode === 200) {
          setList(res.list);
        }
      }
    });
  };

  const getPageList = (page: number, pageSize: number) => {};

  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [currentData, setCurrentData] = useState(null);

  const handleRowSelectionModelChange = (ids) => {
    if (ids.length === 1) {
      setCurrentData(list.find((item) => item.id === ids[0]));
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const [tabIndex, setTabIndex] = useState(0);
  const [showApiKey, setShowApiKey] = useState(false);

  const [openCreate, setOpenCreate] = useState(false);

  useEffect(() => {
    getList();
  }, []);

  return (
    <div>
      <Box>
        <Typography variant="h4">DCP Projects</Typography>
      </Box>

      <Box sx={{ px: 1 }}>
        <Button variant="contained" onClick={() => setOpenCreate(true)}>
          <AddOutlined /> Create project
        </Button>
        <CreateDCP open={openCreate} onClose={() => setOpenCreate(false)} />
      </Box>

      <Box sx={{ mt: 1 }}>
        <ScrollableDataGrid
          rows={list}
          columns={mainColumns}
          loading={isLoading}
          onPageRequest={getPageList}
          disableMultipleRowSelection
          onRowSelectionModelChange={(ids) => {
            handleRowSelectionModelChange(ids);
          }}
        />
      </Box>

      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        centered={!isSmallScreen}
        variant={isSmallScreen ? "scrollable" : "standard"}
        textColor="inherit"
        indicatorColor="primary"
        aria-label="manage member tabs"
      >
        {["Project information", "Usage"].map((name, index) => (
          <Tab
            key={index}
            label={name}
            sx={{ fontWeight: "bold" }}
            {...TabProps(index)}
          />
        ))}
      </Tabs>

      <TabPanel value={tabIndex} index={0} sx={{ minHeight: 200 }}>
        <Box
          sx={{
            width: "100%",
            mt: 1,
            mb: 1,
          }}
        >
          {currentData && (
            <Box sx={{ display: "flex" }}>
              <Box sx={{ width: "50%", p: 1 }}>
                <Grid container>
                  <Grid item xs={6}>
                    Name: {currentData.name}
                  </Grid>
                  <Grid item xs={4}>
                    Identifier: {currentData.identifier}
                  </Grid>
                  <Grid item xs={6}>
                    Public identifier: {currentData.identifier_public}
                  </Grid>
                  <Grid item xs={6}>
                    Host: {currentData.host}
                  </Grid>
                  <Grid item xs={6}>
                    Has website: {currentData.has_website ? "Yes" : "No"}
                  </Grid>
                  <Grid item xs={6}>
                    Website host: {currentData.website_host}
                  </Grid>
                  <Grid item xs={6} sx={{ mt: 2 }}>
                    Created at: {currentData.created_at}
                  </Grid>
                </Grid>
              </Box>
              <Box sx={{ width: "50%" }}>
                <Box sx={{ mt: 1 }}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setShowApiKey(!showApiKey);
                    }}
                  >
                    {showApiKey ? "Hide" : "Show"} API Key
                  </Button>
                  {showApiKey && (
                    <Alert sx={{ mt: 2 }}>{currentData.project_api_key}</Alert>
                  )}
                </Box>
                <Typography sx={{ mt: 2 }} variant="h6">
                  Visit
                </Typography>
                <Box sx={{ mt: 1 }}>
                  <a
                    href={"https://" + currentData.website_host}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button>
                      Website <LaunchOutlined />
                    </Button>
                  </a>
                  <a
                    href={"https://" + currentData.website_host + "/dm_admin"}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <Button>
                      Admin <LaunchOutlined />
                    </Button>
                  </a>
                </Box>

                <Typography sx={{ mt: 2 }} variant="h6">
                  Operation
                </Typography>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <Button variant="outlined" color="warning">
                    Reset data
                  </Button>
                  <Button variant="contained" color="error">
                    Delete project
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </TabPanel>
    </div>
  );
};
